function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    @media (min-width: ",
        ") {\n      ",
        "\n    }\n  "
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    max-width: 90%;\n  "
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    max-width: 28rem;\n    padding: 0;\n  "
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 1rem;\n  \n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n    margin-bottom: 2rem;\n  "
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  text-align: center;\n  margin-bottom: 1.5rem;\n  width: 100%;\n  \n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n    font-size: 1.875rem;\n    margin-bottom: 0.5rem;\n  "
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #4f46e5;\n  margin-bottom: 0.25rem;\n  \n  ",
        "\n  \n  .dark & {\n    color: #818cf8;\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n    font-size: 1.5rem;\n  "
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.25rem;\n  font-weight: 700;\n  \n  ",
        "\n  \n  .dark & {\n    color: #ffffff;\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n    padding: 0.75rem 1rem;\n    margin-bottom: 1.5rem;\n    font-size: 1rem;\n  "
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  background-color: #ebf5ff;\n  border: 1px solid #bfdbfe;\n  color: #1e40af;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.375rem;\n  margin-bottom: 1rem;\n  width: 100%;\n  font-size: 0.875rem;\n  \n  ",
        "\n  \n  .dark & {\n    background-color: rgba(30, 64, 175, 0.2);\n    border-color: rgba(30, 64, 175, 0.3);\n    color: #93c5fd;\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  font-weight: 700;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n    font-size: 0.875rem;\n  "
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  \n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n    font-size: 0.875rem;\n    margin-top: 0.5rem;\n  "
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n  \n  ",
        "\n  \n  strong {\n    font-weight: 600;\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n    gap: 1.25rem;\n  "
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n  padding: 0;\n  \n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n    margin-bottom: 0.5rem;\n  "
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.25rem;\n  \n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  height: 1rem;\n  width: 1rem;\n  color: #4f46e5;\n  border-color: #d1d5db;\n  border-radius: 0.25rem;\n  \n  &:focus {\n    ring-color: #4f46e5;\n  }\n  \n  .dark & {\n    border-color: #4b5563;\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n    font-size: 0.875rem;\n  "
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0.5rem;\n  display: block;\n  font-size: 0.75rem;\n  color: #374151;\n  \n  ",
        "\n  \n  .dark & {\n    color: #d1d5db;\n  }\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n    margin-top: 2rem;\n    font-size: 1rem;\n  "
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  margin-top: 1.5rem;\n  text-align: center;\n  width: 100%;\n  font-size: 0.875rem;\n  \n  ",
        "\n  \n  p {\n    color: #4b5563;\n    \n    .dark & {\n      color: #9ca3af;\n    }\n  }\n  \n  a {\n    color: #4f46e5;\n    \n    &:hover {\n      text-decoration: underline;\n    }\n    \n    .dark & {\n      color: #818cf8;\n    }\n  }\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { css } from '@emotion/react';
// 미디어 쿼리 브레이크포인트
var breakpoints = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
};
// 미디어 쿼리 헬퍼 함수
var media = {
    sm: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject(), breakpoints.sm, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    },
    md: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject1(), breakpoints.md, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    },
    lg: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject2(), breakpoints.lg, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    },
    xl: function(styles) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return css(_templateObject3(), breakpoints.xl, css.apply(void 0, [
            styles
        ].concat(_to_consumable_array(args))));
    }
};
export var LoginFormContainer = styled.div(_templateObject6(), media.sm(_templateObject4()), media.md(_templateObject5()));
export var LogoSection = styled.div(_templateObject8(), media.md(_templateObject7()));
export var LogoTitle = styled.h1(_templateObject10(), media.md(_templateObject9()));
export var LogoSubtitle = styled.h2(_templateObject12(), media.md(_templateObject11()));
export var InfoBox = styled.div(_templateObject14(), media.md(_templateObject13()));
export var InfoTitle = styled.p(_templateObject15());
export var InfoText = styled.p(_templateObject17(), media.md(_templateObject16()));
export var InfoCredential = styled.p(_templateObject19(), media.md(_templateObject18()));
export var Form = styled.form(_templateObject21(), media.md(_templateObject20()));
export var RememberMeContainer = styled.div(_templateObject23(), media.md(_templateObject22()));
export var Checkbox = styled.input(_templateObject24());
export var CheckboxLabel = styled.label(_templateObject26(), media.md(_templateObject25()));
export var FooterText = styled.div(_templateObject28(), media.md(_templateObject27()));
